import { translate, translateFormatter, type RichTextFormatter } from '@/domains/core/localization/translate';
export const {
  queryStringTypeName,
  pleaseConnectText,
  continueShopping,
  itemDeletedSuccess,
  itemDeletedFailed,
  itemSavedSuccess,
  itemSavedFailed,
  itemUnSavedSuccess,
  itemUnSavedFailed,
  itemDeletedSavedSuccess,
  itemDeletedSavedFailed,
  removeFromCartCancel,
  seeProduct,
  itemChangeQuantityFailed,
  singleOutOfStock,
  itemToAsideCartRemovalFailure
} = translate({
  "queryStringTypeName": "basket",
  "continueShopping": "Continue shopping",
  "pleaseConnectText": "Login to access your basket",
  "itemDeletedSuccess": "Bingo! The product has been successfully deleted",
  "itemDeletedFailed": "Ah, there's been a little error - the product has not successfully been deleted",
  "itemSavedSuccess": "The item has been successfully added to your \"Saved for Later\" list and removed from your basket.",
  "itemSavedFailed": "Ah, there's been a little error - the product has not been saved",
  "itemUnSavedSuccess": "Perfect - the product that had been saved has now successfully been added to your basket",
  "itemUnSavedFailed": "Ah, there's been a little error - the product has not successfully been added to your basket",
  "removeFromCartCancel": "Cancel",
  "itemDeletedSavedSuccess": "All good, the product has successfully been deleted",
  "itemDeletedSavedFailed": "Ah, there's been a little error - the product has not successfully been deleted",
  "seeProduct": "See product",
  "itemChangeQuantityFailed": "There was an error when trying to modify the product quantity.",
  "singleOutOfStock": "Product out of stock",
  "itemToAsideCartRemovalFailure": "The item has been successfully added to your \"Saved for Later\" list, but it could not be removed from your basket. You can delete it manually."
});
export const refreshPage = translateFormatter<{
  span: RichTextFormatter;
}>([{
  "type": 0,
  "value": "Failed to load page. Please try again later or "
}, {
  "type": 8,
  "value": "span",
  "children": [{
    "type": 0,
    "value": "refresh page."
  }]
}], undefined, undefined, "en");
export const outOfStock = translateFormatter([{
  "type": 6,
  "value": "count",
  "options": {
    "=1": {
      "value": [{
        "type": 1,
        "value": "count"
      }, {
        "type": 0,
        "value": " product out of stock"
      }]
    },
    "other": {
      "value": [{
        "type": 1,
        "value": "count"
      }, {
        "type": 0,
        "value": " products out of stock"
      }]
    }
  },
  "offset": 0,
  "pluralType": "cardinal"
}], undefined, undefined, "en");
export const productTitle = translateFormatter<{
  nbProducts: number;
}>([{
  "type": 0,
  "value": "Items in your basket"
}], undefined, undefined, "en");